function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 13.13a.96.96 0 01-.33-.06.76.76 0 01-.28-.18L6.24 9.74A.83.83 0 016 9.12c0-.24.08-.45.24-.6a.88.88 0 01.62-.26c.26 0 .46.07.62.23l1.64 1.64V3.87c0-.24.09-.45.26-.62A.85.85 0 0110 3c.25 0 .46.08.62.25.17.17.26.38.26.63v6.25l1.64-1.64a.81.81 0 01.62-.23c.25 0 .46.1.62.25.16.16.24.37.24.62 0 .24-.08.45-.24.6l-3.15 3.16a.76.76 0 01-.28.18.96.96 0 01-.33.06zM4.75 17c-.48 0-.9-.17-1.24-.51A1.69 1.69 0 013 15.25V13.5c0-.25.08-.46.25-.62a.85.85 0 01.63-.26c.24 0 .45.09.62.26.17.16.25.37.25.62v1.75h10.5V13.5c0-.25.08-.46.25-.62a.85.85 0 01.63-.26c.24 0 .45.09.62.26.17.16.25.37.25.62v1.75c0 .48-.17.9-.51 1.24-.35.34-.76.51-1.24.51H4.75z"
});

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.cbc1ef4e.svg";
export { ForwardRef as ReactComponent };